import { useAuth } from "../../context/AuthContext";

const LEVELS = [["all", "All"], ["varsity", "Varsity"], ["jv", "JV"]];

/** Varsity / JV toggle: one team, players tagged by level (same field the GAMEDAY app uses). */
export function LevelSwitch() {
  const { level, setLevel } = useAuth();
  return (
    <div className="px-4 pb-3 lg:px-5">
      <div data-testid="level-switch" className="flex rounded-full border border-[#1E293B] bg-[#0F172A] p-1">
        {LEVELS.map(([val, label]) => (
          <button key={val} data-testid={`level-${val}`} onClick={() => setLevel(val)}
            className={`flex-1 rounded-full px-3 py-1.5 font-mono-gd text-xs font-bold uppercase tracking-wider transition-colors ${level === val ? "bg-[#39FF14] text-[#0A0E1A]" : "text-slate-300 hover:text-white"}`}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
